import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";
import { useEffect } from "react";
import i18next from "i18next";
import "./Cookie.scss";
import useAppStore from "store/store";

const Cookie = () => {

    const setAnalyticsEnabled = useAppStore((state) => state.setAnalyticsEnabled);

    const onPressCookieIcon = () => {
        CookieConsent.showPreferences();
    };

    const onCookiesChanged = ({ cookie }) => {
        setAnalyticsEnabled( cookie.categories.includes('analytics') );
    };

    useEffect(() => {
        CookieConsent.run({
            categories: {
                necessary: {
                    enabled: true,  // this category is enabled by default
                    readOnly: true  // this category cannot be disabled
                },
                analytics: {
                    enabled: true,
                    readOnly: false // this category can be disabled by the user
                }
            },

            language: {
                default: 'nl',
                translations: {
                    nl: {
                        consentModal: {
                            title: i18next.t('cookies.title'),
                            description: i18next.t('cookies.description'),
                            acceptAllBtn: i18next.t('cookies.button_accept_all'),
                            acceptNecessaryBtn: i18next.t('cookies.button_decline_all'),
                            showPreferencesBtn: i18next.t('cookies.button_show_preferences')
                        },
                        preferencesModal: {
                            title: i18next.t('cookies.sections.introduction.title'),
                            acceptAllBtn: i18next.t('cookies.button_accept_all'),
                            acceptNecessaryBtn: i18next.t('cookies.button_decline_all'),
                            savePreferencesBtn: i18next.t('cookies.button_save_preferences'),
                            closeIconLabel: i18next.t('cookies.button_close'),
                            sections: [
                                {
                                    description: i18next.t('cookies.sections.introduction.description')
                                },
                                {
                                    title: i18next.t('cookies.sections.necessary.title'),
                                    description: i18next.t('cookies.sections.necessary.description'),

                                    //this field will generate a toggle linked to the 'necessary' category
                                    linkedCategory: 'necessary'
                                },
                                {
                                    title: i18next.t('cookies.sections.analytics.title'),
                                    description: i18next.t('cookies.sections.analytics.description'),
                                    linkedCategory: 'analytics'
                                },
                            ]
                        }
                    }
                }
            },

            onConsent: onCookiesChanged,
            onChange: onCookiesChanged
        });
    }, []);

    return (
        <div 
            onClick={onPressCookieIcon}
            className="cookie-consent-container">

            <div
                className="cookie-icon-svg"
                dangerouslySetInnerHTML={{
                     __html: '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 120.23 122.88" style="enable-background:new 0 0 120.23 122.88" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M98.18,0c3.3,0,5.98,2.68,5.98,5.98c0,3.3-2.68,5.98-5.98,5.98c-3.3,0-5.98-2.68-5.98-5.98 C92.21,2.68,94.88,0,98.18,0L98.18,0z M99.78,52.08c5.16,7.7,11.69,10.06,20.17,4.85c0.28,2.9,0.35,5.86,0.2,8.86 c-1.67,33.16-29.9,58.69-63.06,57.02C23.94,121.13-1.59,92.9,0.08,59.75C1.74,26.59,30.95,0.78,64.1,2.45 c-2.94,9.2-0.45,17.37,7.03,20.15C64.35,44.38,79.49,58.63,99.78,52.08L99.78,52.08z M30.03,47.79c4.97,0,8.99,4.03,8.99,8.99 s-4.03,8.99-8.99,8.99c-4.97,0-8.99-4.03-8.99-8.99S25.07,47.79,30.03,47.79L30.03,47.79z M58.35,59.25c2.86,0,5.18,2.32,5.18,5.18 c0,2.86-2.32,5.18-5.18,5.18c-2.86,0-5.18-2.32-5.18-5.18C53.16,61.57,55.48,59.25,58.35,59.25L58.35,59.25z M35.87,80.59 c3.49,0,6.32,2.83,6.32,6.32c0,3.49-2.83,6.32-6.32,6.32c-3.49,0-6.32-2.83-6.32-6.32C29.55,83.41,32.38,80.59,35.87,80.59 L35.87,80.59z M49.49,32.23c2.74,0,4.95,2.22,4.95,4.95c0,2.74-2.22,4.95-4.95,4.95c-2.74,0-4.95-2.22-4.95-4.95 C44.54,34.45,46.76,32.23,49.49,32.23L49.49,32.23z M76.39,82.8c4.59,0,8.3,3.72,8.3,8.3c0,4.59-3.72,8.3-8.3,8.3 c-4.59,0-8.3-3.72-8.3-8.3C68.09,86.52,71.81,82.8,76.39,82.8L76.39,82.8z M93.87,23.1c3.08,0,5.58,2.5,5.58,5.58 c0,3.08-2.5,5.58-5.58,5.58s-5.58-2.5-5.58-5.58C88.29,25.6,90.79,23.1,93.87,23.1L93.87,23.1z"/></g></svg>'
                }}>

            </div>
        </div>
    );
}

export default Cookie;